import { motion, Variants } from "framer-motion"

interface TransitionProps {
  variant?: "slide-up" | "fade-in" | "slide-left"
  enabled?: boolean
  children: React.ReactNode
  delay?: number
  transitionKey?: string
  duration?: number
}

export const slideUp: Variants = {
  initial: {
    y: 10,
    opacity: 0,
  },
  enter: {
    y: 0,
    opacity: 1,
  },
  exit: {
    y: -10,
    opacity: 0,
  },
}

export const slideLeft: Variants = {
  initial: {
    x: 10,
    opacity: 0,
  },
  enter: {
    x: 0,
    opacity: 1,
  },
  exit: {
    x: -10,
    opacity: 0,
  },
}

export const fadeIn: Variants = {
  initial: {
    opacity: 0,
  },
  enter: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
}

function Transition(props: TransitionProps) {
  let variants = slideUp

  if (props.variant === "fade-in") {
    variants = fadeIn
  }

  if (props.variant === "slide-left") {
    variants = slideLeft
  }

  if (props.enabled === false) {
    return <>{props.children}</>
  }

  return (
    <motion.div
      key={props.transitionKey || "transition"}
      variants={variants}
      className="h-full"
      initial="initial"
      animate="enter"
      exit="exit"
      transition={{
        duration: props.duration ?? 0.15,
        delay: props.delay ?? 0,
      }}
    >
      {props.children}
    </motion.div>
  )
}

export default Transition
